export default __webpack_public_path__ + "static/media/redux.dfab923e.png";